import { render, staticRenderFns } from "./SignupComponent.vue?vue&type=template&id=18c4c486&scoped=true"
import script from "./SignupComponent.vue?vue&type=script&lang=js"
export * from "./SignupComponent.vue?vue&type=script&lang=js"
import style0 from "./SignupComponent.vue?vue&type=style&index=0&id=18c4c486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4c486",
  null
  
)

export default component.exports